/* Importations Bibliothèques React-router-dom  */

import React from "react";

import GifMireilleRossignol from "../../images/Animations/Vanilla-1s-1920px.webp";
import OrangesEtDentellePresentation from "../../images/Sans-Bordure/SansBordure-Grande-Oranges-Et-Dentelle.webp";
import GrandeAiguierePresentation from "../../images/Sans-Bordure/SansBordure-Grande-Aiguiere.webp";
import SouvenirsMarinsPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Image-Souvenirs-Marins.webp";
import CerisesEtFraisesPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Cerises-Et-Fraises.webp";
import UnPetitNoirPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Un-ptit-noir.webp";
import LeTempsDesLumieresPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Le-Temps-Des-Lumieres-Desir-Grande.webp";
import UnPetitCreuxPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Un-Petit-Creux.webp";
import GrandeCristauxPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Cristaux.webp";
import CuivreEtRaisinDesirPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Cuivre-Et-Raisin-Desir.webp";
import GrandeFruitsDautomnePresentation from "../../images/Sans-Bordure/SansBordure-Grande-Fruits-Dautomne.webp";
import ChienPresentation from "../../images/Grande-Images/Chien.webp";
import ChevalPresentation from "../../images/Grande-Images/Cheval.webp";
import IrisPresentation from "../../images/Grande-Images/Iris.webp";
import NocturnePresentation from "../../images/TableauxVendu/1999/Nocturne.webp";
import TeckelSurVeloursPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Jeune-Teckel-Sur-Velours.webp";
import BebeYorkshireSurVeloursPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Yorkshire-Sur-Velours.webp";
import CanicheAbricotSurVeloursPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Caniche-Abricot-Sur-Velours.webp";
import CanicheBlancSurVeloursPresentation from "../../images/Grande-Images/Grande-Caniche-Blanc-Sur-Velours.webp";
import CanicheGrisSurVeloursPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Caniche-Gris-Sur-Velours.webp";
import GrandeChouetteSurVeloursPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Chouette-Sur-Velours.webp";
import EnLhonneurDeBacchusPresentation from "../../images/Grande-Images/Grande-En-Lhonneur-De-Bacchus.webp";
import YorkshireSurVeloursPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Bebe-Yorkshire-Sur-Velours.webp";
import GuepierSurVeloursPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Guepier-Sur-Velours.webp";
import OiseauBleuSurVeloursPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Oiseau-Bleu-Sur-Velours.webp";
import HamsterSurVeloursPresentation from "../../images/Sans-Bordure/SansBordure-Grande-Hamster-Sur-Velours.webp";
import AvantLeDepartPresentation from "../../images/Grande-Images/Grande-Image-Avant-Le-Départ.webp";
import ChocolatChaudPresentation from "../../images/Grande-Images/Grande-Cafe-Et-Chocolat.webp";
import SouvenirsMarinPresentation from "../../images/TableauxVendu/1998/Cadre-Souvenirs-Marin.webp";
import DentistePresentation from "../../images/TableauxVendu/2002/Dentiste.webp";
import BelleEpoquePresentation from "../../images/TableauxVendu/1997/Belle-Epoque.webp";
import CadreDameJeannePresentation from "../../images/Sans-Bordure/SansBordure-Grande-Dame-Jeanne.webp";
import CaSePreparePresentation from "../../images/TableauxVendu/2005/Cadre-Ca-Se-Prepare.webp";

function Loader() {
  return (
    <div id="loader-Container">
      <div id="loader">
        <img
          id="GifMireilleRossignol"
          src={GifMireilleRossignol}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="OrangesEtDentellePresentation"
          src={OrangesEtDentellePresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="GrandeAiguierePresentation"
          src={GrandeAiguierePresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="SouvenirsMarinsPresentation"
          src={SouvenirsMarinsPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="CerisesEtFraisesPresentation"
          src={CerisesEtFraisesPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="UnPetitNoirPresentation"
          src={UnPetitNoirPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="LeTempsDesLumieresPresentation"
          src={LeTempsDesLumieresPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="UnPetitCreuxPresentation"
          src={UnPetitCreuxPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="YorkshireSurVeloursPresentation"
          src={YorkshireSurVeloursPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="GuepierSurVeloursPresentation"
          src={GuepierSurVeloursPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="GrandeCristauxPresentation"
          src={GrandeCristauxPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="CuivreEtRaisinDesirPresentation"
          src={CuivreEtRaisinDesirPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="GrandeFruitsDautomnePresentation"
          src={GrandeFruitsDautomnePresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="NocturnePresentation"
          src={NocturnePresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="EnLhonneurDeBacchusPresentation"
          src={EnLhonneurDeBacchusPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="AvantLeDepartPresentation"
          src={AvantLeDepartPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="HamsterSurVeloursPresentation"
          src={HamsterSurVeloursPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="OiseauBleuSurVeloursPresentation"
          src={OiseauBleuSurVeloursPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="ChocolatChaudPresentation"
          src={ChocolatChaudPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="SouvenirsMarinPresentation"
          src={SouvenirsMarinPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="DentistePresentation"
          src={DentistePresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="BelleEpoquePresentation"
          src={BelleEpoquePresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="CadreDameJeannePresentation"
          src={CadreDameJeannePresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="CaSePreparePresentation"
          src={CaSePreparePresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="ChienPresentation"
          src={ChienPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="ChevalPresentation"
          src={ChevalPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="IrisPresentation"
          src={IrisPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="TeckelSurVeloursPresentation"
          src={TeckelSurVeloursPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="BebeYorkshireSurVeloursPresentation"
          src={BebeYorkshireSurVeloursPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="CanicheAbricotSurVeloursPresentation"
          src={CanicheAbricotSurVeloursPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="CanicheBlancSurVeloursPresentation"
          src={CanicheBlancSurVeloursPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="CanicheGrisSurVeloursPresentation"
          src={CanicheGrisSurVeloursPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
        <img
          id="GrandeChouetteSurVeloursPresentation"
          src={GrandeChouetteSurVeloursPresentation}
          alt="Titre présentation Mireille Rossignol"
        ></img>
      </div>
    </div>
  );
}
export default Loader;
